import type { ScreenDetails } from '@/contexts/analytics/utils/types';

const SCREEN_MAP: Record<string, ScreenDetails> = {
  '/': {
    screenID: 'home-001',
    screenType: 'Landing',
    screenName: 'Home',
  },
  '/dashboard': {
    screenID: 'dashboard-001',
    screenType: 'Landing',
    screenName: 'Dashboard',
  },
  '/units': {
    screenID: 'units-100',
    screenType: 'List',
    screenName: 'Units List',
  },
  '/units/:unitId': {
    screenID: 'unit-detail-200',
    screenType: 'Detail',
    screenName: 'Unit Details',
  },
  '/campaigns': {
    screenID: 'campaigns-100',
    screenType: 'List',
    screenName: 'Campaigns',
  },
  '/campaigns/:campaignId': {
    screenID: 'campaign-detail-200',
    screenType: 'Detail',
    screenName: 'Campaign Details',
  },
  '/warranty': {
    screenID: 'warranty-100',
    screenType: 'List',
    screenName: 'Warranty',
  },
  '/specifications': {
    screenID: 'specs-100',
    screenType: 'List',
    screenName: 'Specifications',
  },
  '/settings': {
    screenID: 'settings-001',
    screenType: 'Entry',
    screenName: 'Settings',
  },
};

export const getScreenDetails = (pathname: string): ScreenDetails => {
  if (SCREEN_MAP[pathname]) {
    return SCREEN_MAP[pathname];
  }

  for (const [route, details] of Object.entries(SCREEN_MAP)) {
    if (route.includes(':')) {
      const regex = new RegExp('^' + route.replace(/:[^/]+/g, '[^/]+') + '$');
      if (regex.test(pathname)) {
        return details;
      }
    }
  }

  return {
    screenID: 'unknown-000',
    screenType: 'Entry',
    screenName: 'Unknown Page',
  };
};

export const getPageCategory = (pathname: string): string => {
  if (pathname === '/' || pathname === '/dashboard') return 'Dashboard';
  if (pathname.startsWith('/units')) return 'Unit Management';
  if (pathname.startsWith('/campaigns')) return 'Campaigns';
  if (pathname.startsWith('/warranty')) return 'Warranty';
  if (pathname.startsWith('/specifications')) return 'Specifications';
  if (pathname.startsWith('/settings')) return 'Settings';
  return 'General';
};
